export const agataMccarthy = {
    'firstName': 'Agata',
    'lastName': 'McCarthy',
    'profession': 'Psychiatra dzieci i młodzieży',
    'avatar': 'agata-mccarthy.webp',
    'slug': 'psychiatra-dzieciecy-agata-mccarthy',
    'locations': ['torun'],
    'services': [
        ['psychiatry', 'children'],
        ['diagnosis', 'autism']
    ]
}